
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Luxuryforceurbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Luxury Force Urbania On Rent in Pune',
        heading: 'Amruta Travels: Luxury Force Urbania On Rent in Pune',
        headingDescription: 'Amruta Travels offers Luxury Force Urbania on Rent in Pune, providing a premium and comfortable transportation solution for various occasions. Whether you are planning a corporate event, wedding, school trip, or a family outing, our fleet of luxurious Force Urbania vans ensures a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our range of Force Urbania vans, including 10-seater, 13-seater, and 17-seater options, to suit your group size. Book your Luxury Force Urbania with Amruta Travels and travel together in comfort and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
 "services": [
    {
      "name": "Luxury Force Urbania on Rent in Hadapsar",
      "description": "Amruta Travels offers Luxury Force Urbania buses for rent in Hadapsar, Pune. Ideal for premium travel experiences, these mini buses feature plush interiors, air conditioning, and ample space for comfortable journeys to weddings, events, and outstation destinations."
    },
    {
      "name": "13 Seater Force Urbania on Rent in Pune",
      "description": "Hire a 13-seater Force Urbania from Amruta Travels in Pune for small group travel. Perfect for airport transfers, business meetings, and personal tours, these vehicles offer luxury-level comfort, AC, and professional service for city and outstation trips."
    },
    {
      "name": "17 Seater Force Urbania on Rent in Pune",
      "description": "Travel in style with Amruta Travels' 17-seater Force Urbania rentals in Pune. Ideal for mid-size group outings, corporate events, and religious trips, our Urbania buses come equipped with reclining seats, AC, and a smooth suspension system."
    },
    {
      "name": "Urbania Hire in Pune for Outstation",
      "description": "Amruta Travels provides Urbania mini buses on hire from Pune for outstation travel. Whether heading to the hills, coastal areas, or temples, enjoy luxury and convenience in a modern Force Urbania, driven by trained professionals for long-distance comfort."
    },
    {
      "name": "Pune to Lonavala Urbania Bus on Rent",
      "description": "Plan a quick getaway to Lonavala with Amruta Travels’ Force Urbania rentals from Pune. Enjoy air-conditioned comfort, reclining seats, and ample luggage space in a stylish and efficient mini-bus perfect for family trips, group picnics, or weekend tours."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Urbania on Rent",
      "description": "Amruta Travels offers Force Urbania vehicles on rent for the sacred 5 Jyotirlinga Darshan from Pune. Ideal for spiritual travelers, our Urbania buses ensure a clean, punctual, and devotional journey across Maharashtra's religious destinations."
    },
    {
      "name": "Pune Darshan Urbania on Rent",
      "description": "Explore Pune’s cultural and historical landmarks in a luxurious Force Urbania from Amruta Travels. With comfortable seating, AC, and courteous drivers, our Urbania buses are perfect for city tours with families, tourists, or corporate teams."
    },
    {
      "name": "Pune to Nashik Urbania on Rent",
      "description": "Travel from Pune to Nashik in a stylish Force Urbania mini-bus with Amruta Travels. Whether it’s for a pilgrimage, wine tour, or business trip, our Urbania service ensures a comfortable ride with AC, modern interiors, and a reliable chauffeur."
    },
    {
      "name": "Pune to Bhimashankar Urbania Bus Hire",
      "description": "Book a Force Urbania from Pune to Bhimashankar with Amruta Travels for a spiritual and scenic journey. Our vehicles are perfect for temple visits with small to medium groups, offering comfort, cleanliness, and safe travel through winding roads."
    },
    {
      "name": "Pune to Ajanta Ellora Urbania Bus Hire",
      "description": "Discover the UNESCO World Heritage sites of Ajanta and Ellora with Amruta Travels’ Force Urbania rentals from Pune. Enjoy a luxurious and peaceful journey in a well-equipped mini-bus ideal for art lovers, historians, and group explorers."
    }
  ],
  "tableData": [
    ["Luxury Force Urbania on Rent in Hadapsar", "13 Seater Force Urbania on Rent in Pune"],
    ["17 Seater Force Urbania on Rent in Pune", "Urbania Hire in Pune for Outstation"],
    ["Pune to Lonavala Urbania Bus on Rent", "Pune to 5 Jyotirlinga Darshan Urbania on Rent"],
    ["Pune Darshan Urbania on Rent", "Pune to Nashik Urbania on Rent"],
    ["Pune to Bhimashankar Urbania Bus Hire", "Pune to Ajanta Ellora Urbania Bus Hire"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Exclusive and Elegant Travel Experience",
    "WhyChoosedescription": "Amruta Travels offers Luxury Force Urbania On Rent in Pune, providing a premium travel experience with stylish interiors, spacious seating, and cutting-edge amenities for your group or event."
  },
  {
    "WhyChooseheading": "Perfect for Corporate and VIP Travel",
    "WhyChoosedescription": "Ideal for corporate events, executive transport, or VIP group tours, the Luxury Force Urbania ensures comfort and elegance. Your guests will enjoy the spacious cabin, plush seating, and a smooth, luxurious journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "The Force Urbania offers an unparalleled travel experience with its large, comfortable seats, generous legroom, and air-conditioned interiors, making it perfect for long-distance travel or day outings."
  },
  {
    "WhyChooseheading": "Highly Professional and Courteous Drivers",
    "WhyChoosedescription": "Our trained, professional drivers are not only skilled in safe driving but also provide exceptional service, ensuring a pleasant and hassle-free ride throughout your journey."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Transparent Pricing",
    "WhyChoosedescription": "Enjoy the luxury of the Force Urbania at competitive rates. We offer clear, upfront pricing for Luxury Force Urbania On Rent in Pune, so you can plan your travel without worrying about hidden charges."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Vehicles",
    "WhyChoosedescription": "Each Force Urbania is regularly maintained, thoroughly cleaned, and serviced to ensure a pristine travel environment. Travel with confidence knowing that your vehicle is in excellent condition."
  },
  {
    "WhyChooseheading": "Flexible Scheduling and Customizable Routes",
    "WhyChoosedescription": "We offer flexible pick-up and drop-off times and can customize your travel routes based on your specific needs. Whether it’s for a wedding, corporate trip, or sightseeing tour, we’ve got you covered."
  },
  {
    "WhyChooseheading": "Seamless Booking Process with Full Support",
    "WhyChoosedescription": "Booking a Luxury Force Urbania with Amruta Travels is hassle-free. Our easy-to-use booking system, combined with dedicated customer support, ensures your travel experience is stress-free from start to finish."
  }
]































    }

const faqData = [
  {
    question: 'How can I rent a Luxury Force Urbania in Pune with Amruta Travels?',
    answer: 'Renting a Luxury Force Urbania in Pune with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll assist you in selecting the perfect vehicle based on your group size and travel needs.',
  },
  {
    question: 'What makes the Force Urbania a luxury vehicle?',
    answer: 'The Force Urbania offers premium comfort with spacious interiors, comfortable seating, air conditioning, large windows, and modern amenities. It’s designed for a luxurious and smooth ride, ideal for groups looking for a high-end travel experience.',
  },
  {
    question: 'What is the seating capacity of the Luxury Force Urbania?',
    answer: 'The Luxury Force Urbania typically accommodates 13 to 15 passengers comfortably, making it a perfect choice for smaller groups or families who want to travel in style and comfort.',
  },
  {
    question: 'Can the Luxury Force Urbania be used for both local and outstation trips?',
    answer: 'Yes, the Luxury Force Urbania is available for both local trips within Pune and outstation travel to nearby destinations. It’s perfect for long-distance journeys, corporate events, weddings, and more.',
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained and clean?',
    answer: 'Absolutely! All our Luxury Force Urbania vehicles are regularly maintained and cleaned thoroughly before every trip. We ensure the highest standards of hygiene, comfort, and safety.',
  },
  {
    question: 'Does the Luxury Force Urbania come with a driver?',
    answer: 'Yes, every booking for the Luxury Force Urbania includes an experienced, professional driver who ensures smooth, safe, and timely travel throughout your journey.',
  },
  {
    question: 'How much does it cost to rent a Luxury Force Urbania in Pune?',
    answer: 'The cost of renting the Luxury Force Urbania depends on factors such as the duration of the trip, distance, and any additional services you require. Please contact us for a customized and transparent quote.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the Luxury Force Urbania?',
    answer: 'Yes, we offer flexible pickup and drop-off options. Just share your itinerary, and we’ll plan the best route to accommodate your schedule and preferences.',
  },
  {
    question: 'Why should I choose Amruta Travels for Luxury Force Urbania rental in Pune?',
    answer: 'Amruta Travels offers well-maintained Luxury Force Urbania vehicles with premium features, professional drivers, and excellent customer service. We ensure a luxurious, comfortable, and hassle-free journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vikram Deshmukh',
    role: 'Business Executive, Pune',
    text: 'We hired the Luxury Force Urbania for a corporate trip. The vehicle was clean, comfortable, and equipped with everything we needed for a smooth journey. The driver was professional and courteous. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    role: 'Bride-to-be, Pune',
    text: 'Amruta Travels provided the Luxury Force Urbania for our wedding guests. It was a perfect choice for our VIP guests—spacious, comfortable, and luxurious. The ride was smooth, and everyone loved it!',
    rating: 5,
  },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/luxury-force-urbania-rent-pune.jpg",
  "description": "Rent the luxury Force Urbania buses for group travel in Pune. Available in 13 and 17-seater options for outstation trips, temple darshans, and local sightseeing in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "45", // Adjust based on per km or flat rate for Force Urbania rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/luxury-force-urbania-on-rent-in-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Luxury Force Urbania on Rent in Pune | 13 & 17 Seater Urbania Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent luxury Force Urbania buses in Pune for outstation trips, temple darshans, and local sightseeing. Choose from 13 and 17-seater options for a comfortable journey with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxuryforceurbaniaonrentinpune;